module.exports = __webpack_public_path__ + "static/media/no-case.d6bf9af5.png";